<template>
  <div class="px-8 py-6" style="height:100dvh; width:100%;overflow-y: auto;">
    <h3>출고 현황</h3>
    <FilterModal
      :filterList="filterList"
      :listItems="listItems"
      :statusList="statusList"
      :statusName="'출고상태'"
      @sendFilterData="receiveFilterData"
    />
    <div class="align-center d-flex pt-3">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          :items="searchItems"
          item-text="searchText"
          item-value="searchValue"
          v-model="searchCategory"
          solo
          height="26px"
          dense
          class="width100-height30 border-5c5c5c"
          flat
          :menu-props="{ offsetY: true }"
        />
      </div>
      <input
        v-model="searchWord"
        class="cursor-pointer border-5c5c5c back-white width300-height30 mr-3"
        @keyup.enter="startAndReset(1)"
      />
      <v-btn
        color="#3F557D"
        width="78"
        height="30"
        class="color-white mr-3 "
        @click="startAndReset(1)"
      >
        <span class="search-text"> 조회</span>
      </v-btn>
      <v-spacer />
      <InvoiceModal
        @invoiceReset="startAndReset"
        :orderInvoiceStatus="false"
        v-if="roleType != '발주담당자' && !viewerRole"
      />
      <v-btn
        class="border-btn mr-4 ml-2 align-center justify-center d-flex"
        width="120"
        height="30"
        @click="$bus.$emit('smsOpen', 'invoice')"
        v-if="roleType != '발주담당자'"
        :disabled="viewerRole"
      >
        <MsgIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
        <span class="border-text ">발주알림</span>
      </v-btn>
      <v-btn
        class="border-btn mr-4  align-center justify-center d-flex"
        width="120"
        height="30"
        @click="$bus.$emit('InvoiceForm', true)"
        v-if="roleType != '발주담당자'"
        :disabled="viewerRole"
      >
        <UploadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />

        <span class="border-text ">일괄출고</span>
      </v-btn>
      <v-btn
        class="border-btn   align-center justify-center d-flex"
        width="120"
        height="30"
        @click="excelDown"
        :disabled="viewerRole"
      >
        <DownloadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
        <span class="border-text ">내려받기</span>
      </v-btn>
    </div>
    <div class="pt-5">
      <v-simple-table
        ref="tableRef"
        class="width-100"
        fixed-header
        :height="windowInnerHeight - 48 - 260"
        dense
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-center back-8ca9dd color-white border-right-white cursor-pointer first-child1"
                rowspan="2"
                @click="orderByAlone('invoiceCode')"
              >
                <div style="width:80px !important;">
                  발주차수
                  <v-icon color="white">
                    {{
                      orderNameState == "asc"
                        ? "mdi-arrow-up"
                        : "mdi-arrow-down"
                    }}</v-icon
                  >
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white  cursor-pointer first-child2 border-right-white"
                rowspan="2"
                @click="orderByAlone('partName')"
                style="z-index:15 !important"
              >
                <div style="width:230px !important;">
                  부위<v-icon color="white">
                    {{
                      partState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
                    }}</v-icon
                  >
                </div>
              </th>

              <th
                class="floor-td text-center back-8ca9dd color-white "
                style="width:80px"
                rowspan="2"
              >
                동
              </th>
              <th
                class="floor-td text-center back-8ca9dd color-white border-left-white"
                style="width:80px"
                rowspan="2"
              >
                층
              </th>
              <th
                class="floor-td text-center back-8ca9dd color-white border-left-white justify-center align-center "
                style="width:80px"
                rowspan="2"
              >
                부재
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white"
                rowspan="1"
                :colspan="materialLength"
              >
                규격(단위:TON)
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white "
                rowspan="2"
              >
                <div>
                  합계수량
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white border-right-white"
                rowspan="2"
              >
                <div class="w-70 text-center">
                  입고여부
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white cursor-pointer word-keep-all"
                rowspan="2"
                @click="orderByAlone('dueDate')"
              >
                <div class="text-center d-flex flex-column px-1">
                  입고 예정일자
                  <v-icon color="white">
                    {{
                      dueDateState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
                    }}
                  </v-icon>
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white  cursor-pointer border-right-white"
                rowspan="2"
                @click="orderByAlone('date')"
              >
                <div class="text-center">
                  출고일자
                  <v-icon color="white">
                    {{ dateState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down" }}
                  </v-icon>
                </div>
              </th>

              <th
                class="no-min-width text-center back-8ca9dd color-white border-left-white"
                rowspan="2"
              >
                <div class="text-center">
                  가공장
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white"
                rowspan="2"
              >
                <div class="text-center">
                  송장번호
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white border-left-white"
                rowspan="2"
              >
                <div style="width:80px">
                  QR코드
                </div>
              </th>
              <th class="text-center back-8ca9dd color-white" rowspan="2">
                <div>
                  메모
                </div>
              </th>
            </tr>
            <tr>
              <th
                class="back-8ca9dd color-white text-center border-top-white border-left-white"
                v-for="list in materialList"
                :key="list.rebar_id"
              >
                {{ list.rebar_name }}
              </th>
            </tr>
            <tr v-if="invoiceList.length > 0">
              <th
                colspan="2"
                class="border-left-aaaaaa border-right-aaaaaa back-cadbf9 text-center border-bottom-aaaaaa first-child1"
              >
                총합
              </th>
              <th class="border-right-aaaaaa back-ecf3f9" colspan="3"></th>
              <th
                v-for="(invoiceList, index) in invoiceSumList"
                :key="index"
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa back-ecf3f9"
              >
                {{ invoiceList ? mathRound(invoiceList).toFixed(3) : "0" }}
              </th>
              <th
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa back-ecf3f9"
              >
                {{ sum(invoiceSumList).toFixed(3) }}
              </th>
              <th
                colspan="8"
                class="border-right-aaaaaa border-bottom-aaaaaa back-ecf3f9"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in tbodyLength" :key="index">
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa text-center back-f5f5f5 first-child1"
              >
                {{ invoiceList[index - 1].orderName }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa  text-center width-200 back-f5f5f5 first-child2"
              >
                <v-btn
                  @click="
                    $bus.$emit(
                      'invoiceDetail',
                      invoiceList[index - 1].invoiceId
                    )
                  "
                  color="#0038FF"
                  text
                  width="230"
                  class="part-btn text-start font-12"
                >
                  {{ invoiceList[index - 1].partName }}
                </v-btn>
              </td>

              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center px-1 font-12"
              >
                {{ invoiceList[index - 1].dong }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center px-1 font-12"
              >
                {{ invoiceList[index - 1].floor }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center px-1 font-12"
              >
                {{ invoiceList[index - 1].type }}
              </td>

              <td
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa"
                v-for="(inList, i) in invoiceList[index - 1]
                  .regacyInvoiceSumList"
                :key="i"
              >
                {{ inList ? mathRound(inList).toFixed(3) : "0" }}
              </td>
              <td
                class="border-right-aaaaaa text-right px-1 border-bottom-aaaaaa"
              >
                {{
                  sum(invoiceList[index - 1].regacyInvoiceSumList).toFixed(3)
                }}
              </td>
              <td
                class="w-70 border-right-aaaaaa text-center border-bottom-aaaaaa"
              >
                <span
                  :class="
                    invoiceList[index - 1].completion == 'Y'
                      ? 'color-37AC00'
                      : 'color-888888'
                  "
                >
                  {{
                    invoiceList[index - 1].completion == "Y"
                      ? "입고완료"
                      : "출고완료"
                  }}
                </span>
              </td>
              <td
                class="w-70 border-right-aaaaaa text-center border-bottom-aaaaaa"
              >
                {{ dateCheck(invoiceList[index - 1].dueDate) }}
              </td>
              <td
                class="w-70 text-center border-right-aaaaaa border-bottom-aaaaaa"
              >
                {{ dateCheck(invoiceList[index - 1].registDate) }}
              </td>

              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center px-1"
                style="min-width: 100px;max-width: 140px;"
              >
                {{ invoiceList[index - 1].invoiceCompany }}
              </td>

              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center gr-code px-1"
                style="min-width: 100px;max-width: 140px;"
              >
                {{ invoiceList[index - 1].invoiceInputCode }}
              </td>

              <td
                class="border-right-aaaaaa text-center  color-0038FF border-bottom-aaaaaa"
              >
                <v-btn
                  width="100%"
                  @click="
                    $bus.$emit(
                      'qrCodeView',
                      invoiceList[index - 1].invoiceId,
                      'invoice'
                    )
                  "
                  color="#0038FF"
                  text
                  :disabled="viewerRole"
                >
                  QR보기
                </v-btn>
              </td>
              <td class="border-right-aaaaaa text-center  border-bottom-aaaaaa">
                <v-btn
                  width="100%"
                  @click="
                    memoClick(invoiceList[index - 1].invoiceId, 'invoice')
                  "
                  :color="invoiceList[index - 1].memo ? '#0038FF' : '#ff0000'"
                  text
                  :disabled="invoiceList[index - 1].memo ? false : viewerRole"
                >
                  {{ invoiceList[index - 1].memo ? "보기" : "추가" }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="mt-3 justify-center pb-4 mb-4">
      <v-pagination
        v-model="page"
        color="#8EB4FA"
        :length="pageLength"
        v-if="invoiceList.length > 0"
        :total-visible="10"
      ></v-pagination>
    </div>
    <Detail />
    <QrCode />
    <InvoiceForm />
  </div>
</template>

<script>
import DatePickerMixin from "@/mixin/DatePicker";
import Search from "@/mixin/Search";
import DatePicker from "@/components/DatePicker";
import FilterModal from "@/components/Filter";
import InvoiceApi from "@/api/InvoiceService";
import FileApi from "@/api/FileService";
import Commonality from "@/mixin/Commonality";
import Detail from "./InvoiceDetail";
import InvoiceForm from "../modal/InvoiceForm.vue";
import fileDownload from "@/assets/js/file-download";
import UploadIcon from "@/assets/svgs/UploadIcon.vue";
import DownloadIcon from "@/assets/svgs/DownloadIcon.vue";
import MsgIcon from "@/assets/svgs/MsgIcon.vue";

import InvoiceModal from "./modal/InvoiceModal";
import QrCode from "./modal/QrViewer";

export default {
  mixins: [DatePickerMixin, Search, Commonality],

  components: {
    DatePicker,
    InvoiceModal,
    Detail,
    QrCode,
    InvoiceForm,
    FilterModal,
    UploadIcon,
    DownloadIcon,
    MsgIcon,
  },

  data: () => ({
    dateItems: ["발주일자"],
    invoiceList: [],
    invoiceTotalList: [],
    invoiceSumList: [],
    orderNameState: "desc",
    partState: null,
    dueDateState: null,
    dateState: null,
    tbodyLength: 0,
    filterList: {},
    listItems: [{ searchText: "출고일자", searchValue: 1 }],
    methodFilterData: {},
    statusList: [
      {
        name: "입고완료",
        status: true,
      },
      {
        name: "출고완료",
        status: true,
      },
    ],
    windowInnerHeight: 0,
  }),

  created() {
    if (!this.isStoreFilter) {
      this.startAndReset();
    }
    this.$bus.$on("invoiceNavigationDuplicated", () => {
      this.startAndReset(1);
    });
  },

  beforeDestroy() {
    this.$bus.$off("invoiceNavigationDuplicated");
  },
  watch: {
    page(val) {
      this.startAndReset(val);
      this.scrollTop();
    },
  },
  computed: {
    materialLength() {
      return this.materialList.length;
    },
    /** 저장된 필터 있는지 여부 */
    isStoreFilter() {
      return this.$store.getters?.getInvoiceFilter;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },

  methods: {
    /** table Scroll top 이동함수 */
    scrollTop() {
      const container = this.$refs.tableRef?.$el?.querySelector(
        ".v-data-table__wrapper"
      );
      if (container) {
        container.scrollTop = 0;
      }
    },
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    orderByAlone(payload) {
      if (payload == "invoiceCode") {
        this.dateState = null;
        this.partState = null;
        this.dueDateState = null;
        this.orderNameState =
          this.orderNameState && this.orderNameState != "asc" ? "asc" : "desc";
      } else if (payload == "partName") {
        this.orderNameState = null;
        this.dateState = null;
        this.dueDateState = null;
        this.partState =
          this.partState && this.partState != "asc" ? "asc" : "desc";
      } else if (payload == "dueDate") {
        this.orderNameState = null;
        this.partState = null;
        this.dateState = null;
        this.dueDateState =
          this.dueDateState && this.dueDateState != "asc" ? "asc" : "desc";
      } else if (payload == "date") {
        this.orderNameState = null;
        this.partState = null;
        this.dueDateState = null;
        this.dateState =
          this.dateState && this.dateState != "asc" ? "asc" : "desc";
      }
      this.startAndReset();
    },

    async startAndReset(payload) {
      if (payload) {
        this.page = payload;
      }
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        currentPage: payload ? payload : this.page,
        startDate: this.startDate,
        endDate: this.finishDate,
        order: [
          this.orderNameState,
          this.partState,
          this.dueDateState,
          this.dateState,
        ],
        pagingCount: 20,
        keyword: this.searchWord,
        type: this.searchCategory,
      };
      data = Object.assign(data, this.methodFilterData);
      this.materialLengh = this.materialList.length;
      let result = await InvoiceApi.invoiceTotalList(data);
      this.invoiceTotalList = result.data.invoiceList;
      this.invoiceList = this.invoiceTotalList;
      this.invoiceSumList = result.data.InvoiceTotalList.totalInvoice[0];
      this.tbodyLength = result.data.invoiceList.length;
      this.pageLength = result.data.pageInfo.endPage;
      let res = await InvoiceApi.invoiceFilterListSearch(data);
      this.filterList = res.data;
      this.$bus.$emit("loadingEnd");
    },

    async excelDown() {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        startDate: this.startDate,
        endDate: this.finishDate,
        order: [
          this.orderNameState,
          this.partState,
          this.dueDateState,
          this.dateState,
        ],
        keyword: this.searchWord,
        type: this.searchCategory,
      };
      data = Object.assign(data, this.methodFilterData);
      let res = await FileApi.invoiceDown(data);
      if (res.data.size > 0) {
        fileDownload(
          res.data,
          `${this.constructionName.constructionName} 출고현황.xlsx`
        );
      } else {
        this.$bus.$emit("dialog", "서버 문제로 잠시후 실행해주세요.");
      }
      this.$bus.$emit("loadingEnd");
    },

    receiveFilterData(data) {
      this.methodFilterData = data;
      this.searchWord = "";
      this.startAndReset(1);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}
.first-child1 {
  position: sticky;
  left: 0;
  z-index: 8 !important;
}
.first-child2 {
  position: sticky;
  left: 81px;
  width: 224px;
}
.first-child3 {
  position: sticky;
  left: 321px;
  z-index: 8 !important;
}
.color-37AC00 {
  color: #37ac00;
}
.color-888888 {
  color: #888888;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 100%;
}
.font-12 {
  font-size: 12px;
}
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.part-btn {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.width-200 {
  width: 200px;
}

.word-keep-all {
  word-break: keep-all;
}

.back-fb {
  background: #fbfbfb;
  height: 100%;
}

.width100-height30 {
  width: 100px !important;
  height: 30px !important;
}

.width179-height41 {
  width: 179px;
  height: 41px !important;
}

.v-input__control {
  height: 41px !important;
}

.v-text-field {
  height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 38px !important;
  margin: 0px;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #efefef;
}

.v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #efefef;
}
.cnt-td {
  min-width: fit-content;
  max-width: 120px;
}
.floor-td {
  min-width: 80px;
  max-width: 120px;
}
.w-70 {
  min-width: 70px !important;
}
.gr-code {
  min-width: fit-content;
  max-width: 140px;
}
.no-min-width {
  min-width: 0 !important;
}

@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
</style>
